export const PAYMENT_METHODS = {
    card: 'card',
    onhouse: 'onhouse',
    cash: 'cash',
    hold: 'hold',
    terminal: 'terminal',
    check: 'check',
    balance: 'balance'
};

export const PAYMENT_METHOD_TYPES_AGENT_ONLY = [
    PAYMENT_METHODS.onhouse,
    PAYMENT_METHODS.terminal,
    PAYMENT_METHODS.cash,
    PAYMENT_METHODS.balance
];

// methods that can be used to fill up balance
export const PAYMENT_METHODS_BALANCE_FILLING = [
    PAYMENT_METHODS.onhouse,
    PAYMENT_METHODS.card,
    PAYMENT_METHODS.cash,
    PAYMENT_METHODS.check
];

/**
 * The order of this list will define the order on the payment list
 * @type {{id: string, name: string, labelForPaymentPage: string, agentOnly: boolean}[]}
 */
export const PAYMENT_METHOD_LIST = [
    {
        id: PAYMENT_METHODS.card,
        name: 'Pay via Card',
        labelForPaymentPage: 'Credit card (charge)',
        agentOnly: false
    },
    {
        id: PAYMENT_METHODS.hold,
        name: 'Place hold on Card',
        labelForPaymentPage: 'Credit card (hold)',
        agentOnly: false
    },
    {
        id: PAYMENT_METHODS.onhouse,
        name: 'Agents can charge to House Account',
        labelForPaymentPage: 'On house account booking',
        agentOnly: true
    },
    {
        id: PAYMENT_METHODS.terminal,
        name: 'Pay with Stripe terminal',
        labelForPaymentPage: 'Pay with Stripe Terminal',
        agentOnly: true
    },
    {
        id: PAYMENT_METHODS.cash,
        name: 'Via Cash',
        labelForPaymentPage: 'Pay with cash',
        agentOnly: true
    },
    {
        id: PAYMENT_METHODS.check,
        name: 'Pay by Check',
        labelForPaymentPage: 'Pay by check',
        agentOnly: false
    },
    {
        id: PAYMENT_METHODS.balance,
        name: 'Balance Payment',
        labelForPaymentPage: 'Pay with balance',
        agentOnly: false
    }
];

// well, this is a global variable that includes payment_methods
// a sample item: {
//     "slug": "123",
//     "name": "adsf",
//     "methodtype": "cash",
//     "note_required": true
// }
let paymentMethod = [];

/**
 * Hardwire payment methods
 * @param newPaymentMethod
 */
export function setPaymentMethods(newPaymentMethod) {
    paymentMethod = newPaymentMethod;
}

/**
 * Grab current payment method
 * @returns {string}
 */
export function usePaymentMethods() {
    // just return a plain payment method
    return paymentMethod;
}
